module.exports = __webpack_public_path__ + "static/media/JohnMuir.9b66d2e7.png";